<template>
    <div>
        <CommonTitle
            :title="modelTitle"
            :showMore="true"
            @goMore="starHome"
            :tag-list="tagList"
            @changeTag="onChangeTag"
        />
        <ul class="resource-list" v-if="realList.length">
            <li
                class="resource-list-item"
                v-for="item in realList"
                :key="item.assetId"
                @click="toDetail(item.assetId)"
            >
                <div class="list-item-link" v-link="linkUrl(item.assetId)">
                    <div class="list-item-img">
                        <img :src="fileType(item.firstMaterialType, 'big')" alt="" />
                    </div>
                    <div class="list-item-content">
                        <div class="resource-title text-overflow" :title="item.assetTitle">
                            {{ item.assetTitle }}
                        </div>
                        <span v-if="item.tagName" class="tag" :class="`tag-${item.tagIndex}`">{{
                            item.tagName
                        }}</span>
                        <div class="resource-desc-box">
                            <span class="download-num">{{ item.creatorName }}</span>
                            <span class="upload-time" :title="item.creatorStandardSchoolName">{{
                                item.creatorStandardSchoolName
                            }}</span>
                        </div>
                    </div>
                    <div class="resource-label" v-if="item.categoryShow">
                        {{ item.categoryShow }}
                    </div>
                </div>
            </li>
        </ul>
        <BigNoData
            v-else
            class="no-data"
            url="no-course.png"
            :info="`暂无${modelTitle || '资源'}`"
        />
    </div>
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/index.vue';
import BigNoData from '@/components/no-data.vue';
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import { pageJump } from '@/global/location-transfer';
import { fileType } from '@/views/resource-issue/resource-issue.js';
import { jumpHref } from '@/router/jumpHref.js';

const props = defineProps({
    modelTitle: {
        type: String,
        default: '',
    },
    tagList: {
        type: Array,
        default: () => {
            return [];
        },
    },
    doubleNew: {
        type: Boolean,
        default: false,
    },
});

const store = useStore();

const list = ref([]);
const homepageStagesStr = ref('');

const realList = computed(() => {
    return (list.value?.length && list.value.slice(0, 4)) || [];
});

const getList = function () {
    G_transmit('getCommunityAssetList', {
        name: 'getCommunityAssetList',
        queries: {
            pageSize: 5,
            pageIndex: 1,
            orderBy: 'desc', // 升降序 asc-升序,desc-降序
            sortBy: 'hotNum', // 排序字段 hotNum-热度
            openScope: 'community_open',
            requestSource: 'homepage',
            homepageStagesStr: homepageStagesStr.value,
        },
    }).then(res => {
        let data = res?.data?.rows || [];
        list.value =
            data.length &&
            data.map(item => {
                let tag = fmtTag(item) || {};
                item.tagName = tag.categoryName;
                item.tagIndex = tag.categoryColorIndex;
                return item;
            });
    });
};

function starHome() {
    pageJump({ name: 'resource' });
}

// 跳转资源详情
function toDetail(id) {
    pageJump(jumpHref.resource.detail(id), true);
}

function linkUrl(id) {
    return {
        url: jumpHref.resource.detail(id),
        className: 'link-item',
    };
}

function fmtTag(item) {
    return (item.categoryInfoList?.length && item.categoryInfoList[0]) || {};
}

const onChangeTag = tag => {
    homepageStagesStr.value = tag.join(',');
    getList();
};

onMounted(() => {
    let tag = props.doubleNew ? [1204] : [];
    onChangeTag(tag);
});
</script>

<style lang="scss" scoped>
.resource-list {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
}
.resource-list-item {
    box-sizing: border-box;
    width: 585px;
    height: 110px;
    position: relative;
    border-radius: 4px;
    margin-top: 30px;
    margin-left: 30px;
    background: var(--home-color-bg-ligter);
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 30px;
    cursor: pointer;
    &:hover {
        box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.15);
        .resource-title {
            color: var(--home-main-color) !important;
        }
    }

    &:nth-child(1),
    &:nth-child(2) {
        margin-top: 26px;
    }

    .list-item-img {
        width: 60px;
        height: 60px;
        img {
            width: 60px;
            height: 60px;
        }
    }
    .list-item-content {
        box-sizing: border-box;
        width: 0;
        flex: 1;
        margin-left: 17px;
        .resource-title {
            font-size: 18px;
            line-height: 18px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: var(--color-black);
        }
        .resource-desc-box {
            margin-top: 20px;
            display: flex;
            align-items: center;
            .download-icon {
                width: 16px;
                height: 16px;
            }
            .download-num {
                font-size: 14px;
                font-weight: 400;
                color: var(--color-black);
                line-height: 1.5;
                margin-right: 8px;
            }
            .upload-time {
                font-size: 14px;
                font-weight: 400;
                color: var(--color-gray);
                max-width: 180px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    .resource-label {
        height: 24px;
        position: absolute;
        top: 0;
        right: 0;
        background: #d8f1e4;
        border-radius: 0px 4px 0px 4px;
        padding-left: 12px;
        padding-right: 12px;
        font-size: 14px;
        font-weight: 400;
        color: #089950;
        line-height: 24px;
    }
    .tag {
        border-radius: 0px 4px 0px 4px;
        position: absolute;
        right: 0px;
        top: 0px;
        padding: 2px 12px;
        background: #d8f1e4;
        color: #089950;

        &.tag-1 {
            background: #d8f1e4;
            color: #089950;
        }
        &.tag-2 {
            background: #fdefcd;
            color: #b27121;
        }
        &.tag-3 {
            background: #deebfd;
            color: #197fd7;
        }
    }
}

:deep(.link-item) {
    width: 100%;
    .list-item-link {
        display: flex;
        align-items: center;
    }
}
.resource-list-item:nth-child(2n + 1) {
    margin-left: 0;
}
.ellipsis-2 {
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.no-data {
    margin-top: 50px;
}
.text-overflow {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
